import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_bestseller_restock: FaireThemeEntity = {
  token: "discovery_theme_bestseller-restock",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Bestseller Restock",
  description: "Top sellers your customers keep coming back for",
  bgColor: "#F5E0D4",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
